import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-chevron';
export var ID = 'icon-chevron';
/* eslint-disable max-len */

export var SVGChevron = function SVGChevron() {
  return React.createElement("symbol", {
    viewBox: "0 0 13 8",
    id: ID
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-195.000000, -84.000000)"
  }, React.createElement("path", {
    d: "M195.134,85.325 L200.97,91.16 C201.037,91.25 201.15,91.295 201.239,91.295 C201.352,91.295 201.464,91.25 201.531,91.16 L207.367,85.325 C207.457,85.235 207.502,85.145 207.502,85.033 C207.502,84.943 207.457,84.831 207.367,84.741 L206.739,84.135 C206.671,84.045 206.559,84 206.469,84 C206.357,84 206.245,84.045 206.178,84.135 L201.239,89.051 L196.324,84.135 C196.234,84.045 196.144,84 196.032,84 C195.92,84 195.83,84.045 195.74,84.135 L195.134,84.741 C195.044,84.831 195,84.943 195,85.033 C195,85.145 195.044,85.235 195.134,85.325"
  }))));
};
/* eslint-disable max-len */

var Chevron = function Chevron(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGChevron
  });
};

Chevron.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Chevron;